import { Typography } from '@mui/material';

import BackHomeButton from './BackHomeButton';
import ErrorLayout from './ErrorLayout';

const Alert = () => {
  return (
    <Typography variant="mono" sx={{ fontSize: 48, fontWeight: 500 }}>
      404
    </Typography>
  );
};

const MessageLineOne = () => (
  <Typography variant="h4">{`The page you're looking for can't be found.`}</Typography>
);

const Page404 = () => {
  return (
    <ErrorLayout
      MessageLineOne={MessageLineOne}
      MessageLineTwo={BackHomeButton}
      Alert={Alert}
    />
  );
};

export default Page404;
